export const ModalBody = (props) => <div class='control-modal-body'>{props.children}</div>
